module.exports = __webpack_public_path__ + "img/business.568ab2ba.png";